<template>
  <div class="three-images-with-text">
    <div class="row">
      <div class="col">
        <div class="image">
          <div
            class="bg"
            v-if="content.image_one"
            :style="`background-image: url(${content.image_one.sizes.large})`"
            v-on:click="imageClick(content.image_one.sizes.large, content.image_one.caption)"
          ></div>
          <div
            class="post-image-caption"
            v-if="content.image_one && content.image_one.caption"
            v-html="content.image_one.caption"
          ></div>
        </div>
      </div>
      <div class="col big">
        <div class="text" v-html="content.text"></div>
      </div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col big">
        <div class="image square">
          <div
            class="bg"
            v-if="content.image_two"
            :style="`background-image: url(${content.image_two.sizes.large})`"
            v-on:click="imageClick(content.image_two.sizes.large, content.image_two.caption)"
          ></div>
          <div
            class="post-image-caption"
            v-if="content.image_two && content.image_two.caption"
            v-html="content.image_two.caption"
          ></div>
        </div>
        <div class="image square">
          <div
            class="bg"
            v-if="content.image_three"
            :style="`background-image: url(${content.image_three.sizes.large})`"
            v-on:click="imageClick(content.image_three.sizes.large, content.image_three.caption)"
          ></div>
          <div
            class="post-image-caption"
            v-if="content.image_three && content.image_three.caption"
            v-html="content.image_three.caption"
          ></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col full">
        <div class="image tablet">
          <div
            class="bg"
            v-if="content.image_three"
            :style="`background-image: url(${content.image_three.sizes.large})`"
            v-on:click="imageClick(content.image_three.sizes.large, content.image_three.caption)"
          ></div>
          <div
            class="post-image-caption"
            v-if="content.image_three && content.image_three.caption"
            v-html="content.image_three.caption"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "three_images_with_text",
  props: {
    content: Object,
    imageClick: Function
  }
};
</script>

<style lang="scss">
.three-images-with-text {
  .row {
    display: flex;
    align-items: center;
    .col {
      flex: 0.35;
      &.big {
        flex: 0.65;
      }
      &.full {
        margin-top: 25px;
        flex: 1;
        display: none;
      }
      .image {
        position: relative;
        width: 100%;
        height: 500px;
        background: rgba(0, 0, 0, 0.1);
        position: relative;
        z-index: 2;
        .bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-position: center center;
          background-size: cover;
          cursor: pointer;
        }
        &.square {
          width: 40%;
          height: 0;
          padding-top: 40%;
          display: inline-block;
          margin-right: 30px;
        }
      }
      .text {
        position: relative;
        padding: 50px 100px;
        z-index: 1;
      }
    }
  }
}
@media (max-width: $tablet) {
  .three-images-with-text {
    .row {
      .col {
        &.full {
          display: block;
        }
        .text {
          padding: 50px;
        }
        .image {
          height: 400px;
          &.square {
            width: 90%;
            padding-top: 60%;
            &:nth-child(2) {
              display: none;
            }
          }
        }
      }
    }
  }
}
@media (max-width: $mobile) {
  .three-images-with-text {
    .row {
      flex-direction: column;
      .col {
        flex: 1;
        width: 100%;
        &.full {
          display: none;
        }
        &.big {
          flex: 1;
        }
        .text {
          padding: 25px 0;
          width: 90%;
          margin: 0 auto;
        }
        .image {
          height: 320px;
          &.square {
            display: block;
            width: 100%;
            padding-top: 60%;
            margin: 0 auto;
            &:nth-child(2) {
              margin-top: 25px;
              display: block;
            }
          }
        }
      }
    }
  }
}
@media (max-width: $small-mobile) {
  .three-images-with-text {
    .row {
      .col {
        .image {
          height: 240px;
        }
      }
    }
  }
}
</style>